import * as React from 'react';
import IconImage from '../common/IconImage';
import ToolIcon from '../common/ToolIcon';
import { getBasePath } from '../../utils/browser';

const handerasingWidthName: {[key: number]: string} = {
  10: '1',
  20: '2',
  40: '3',
  80: '4',
  160: '5',
};

const pathToImage = 'images/tool-icons/dynamic/handerasing';

interface HanderasingToolIconProps {
  readonly style?: React.CSSProperties;
  readonly svgStyle?: React.CSSProperties;
  readonly width: number;
}

const HanderasingToolIcon: React.SFC<
  HanderasingToolIconProps
> = React.memo((props) => {
  const { style, svgStyle, width } = props;

  const baseDir = getBasePath();
  const imageName = `icon_eraser_size_0${handerasingWidthName[width]}.png`;
  const src = `${baseDir}/${pathToImage}/${imageName}`;

  return (
    <ToolIcon title={`消しゴム(太さ${handerasingWidthName[width]})`} style={style}>
      <IconImage src={src} svgStyle={svgStyle} />
    </ToolIcon>
  );
});

export default HanderasingToolIcon;
